import {
  LOADED_COORDENADORES_PAGE_ACTION,
  CLEARED_COORDENADORES_PAGE_ACTION,
  CHANGED_COORDENADOR_EDITING_VALUE_ACTION,
  CLEARED_COORDENADOR_ACTION,
  LOADED_COORDENADOR_ACTION,
  CHANGE_COORDENADOR_STATUS_ACTION,
  RESETED_COORDENADORES,
  REMOVING_COORDENADOR_ACTION,
} from './CoordenadoresActions';
import { transformNullIntoEmpty } from '../../utils/DataUtils';
import { TOTAL_ITEMS_FOR_PAGE } from '../../utils/PaginationUtils';
import { SET_NAME } from './ProfessoresActions';
import { CLEAR_NAME_ACTION } from './AssessoresActions';

const PAGE_LIST_INITIAL_STATE = {
  busca: '',
  page: -1,
  totalElements: 0,
  totalPages: 0,
  elements: [],
};

const COORDENADOR_EDITING_NOT_NULL_PROPS = [
  'nome',
  'celular',
  'email',
  'mae',
  'dataNascimento',
  'rg',
  'cpf',
  'coop',
  'estado',
  'cidade',
];

const COORDENADOR_EDITING_INITIAL_STATE = {
  nome: '',
  celular: '',
  email: '',
  mae: '',
  dataNascimento: '',
  rg: '',
  cpf: '',
  coop: '',
  estado: '',
  idEstado: -1,
  cidade: '',
};

const INITIAL_STATE = {
  pageSize: TOTAL_ITEMS_FOR_PAGE,

  pageList: PAGE_LIST_INITIAL_STATE,

  /* object {
    nome: string,
    celular: string,
    email: string,
    mae: string,
    dataNascimento: string,
    rg: string,
    cpf: string,
    cooperativa: string,
    estado: string,
    idEstado: integer,
    cidade: string
  }*/
  coordenadorEditing: COORDENADOR_EDITING_INITIAL_STATE,

  removingCoordenador: false,

  cordenadorName: null,
};

const getRefreshedPageList = (lastPageList, newPageList) => {
  return {
    ...lastPageList,
    busca: newPageList.busca,
    page: newPageList.page,
    totalElements: newPageList.totalElements,
    totalPages: newPageList.totalPages,
    elements: [...lastPageList.elements, ...newPageList.elements],
  };
};

const getChangedStatusList = (pageList, cpf, status) => {
  let newPageList = {
    ...pageList,
    elements: [],
  };
  pageList.elements.map((element, index) => {
    if (element.cpf === cpf) {
      newPageList.elements.push({
        ...element,
        status,
      });
    } else {
      newPageList.elements.push(element);
    }
    return index;
  });
  return newPageList;
};

export default function CoordenadoresReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case RESETED_COORDENADORES:
      return {
        ...INITIAL_STATE,
      };
    case SET_NAME:
      if (action.payload.type === 'assessorName') {
        return {
          ...state,
          assessorName: action.payload.value,
          professorName: null,
          cordenadorName: null,
        };
      } else if (action.payload.type === 'professorName') {
        return {
          ...state,
          professorName: action.payload.value,
          assessorName: null,
          cordenadorName: null,
        };
      } else if (action.payload.type === 'cordenadorName') {
        return {
          ...state,
          cordenadorName: action.payload.value,
          professorName: null,
          assessorName: null,
        };
      }
      return state;
    case CLEAR_NAME_ACTION:
      return {
        ...state,
        assessorName: null,
        professorName: null,
        cordenadorName: null,
      };
    case LOADED_COORDENADORES_PAGE_ACTION:
      return {
        ...state,
        pageList: getRefreshedPageList(state.pageList, action.payload),
      };
    case LOADED_COORDENADOR_ACTION:
      return {
        ...state,
        coordenadorEditing: transformNullIntoEmpty(
          action.payload,
          COORDENADOR_EDITING_NOT_NULL_PROPS
        ),
      };
    case CLEARED_COORDENADOR_ACTION:
      return {
        ...state,
        coordenadorEditing: COORDENADOR_EDITING_INITIAL_STATE,
      };
    case CHANGE_COORDENADOR_STATUS_ACTION:
      return {
        ...state,
        pageList: getChangedStatusList(
          state.pageList,
          action.payload.cpf,
          action.payload.status
        ),
      };
    case CLEARED_COORDENADORES_PAGE_ACTION:
      return { ...state, pageList: PAGE_LIST_INITIAL_STATE };
    case CHANGED_COORDENADOR_EDITING_VALUE_ACTION:
      return {
        ...state,
        coordenadorEditing: {
          ...state.coordenadorEditing,
          [action.payload.name]: action.payload.value,
        },
      };
    case REMOVING_COORDENADOR_ACTION:
      return {
        ...state,
        removingCoordenador: action.payload,
      };
    default:
      return state;
  }
}
